export default "__VITE_ASSET__YQxqO0VF__"